import React from "react";

const CampaignBatchModal = ({ isOpen, onClose, allBatches }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg w-4/5 max-w-3xl shadow-lg max-h-screen overflow-y-auto">
                {/* Modal Header */}
                <div className="flex justify-between items-center bg-gray-200 px-4 py-2 rounded-t-lg">
                    <h2 className="text-xl font-bold">Campaign Batches</h2>
                    <button
                        onClick={onClose}
                        className="text-red-600 hover:text-gray-900 text-2xl font-bold"
                    >
                        &times;
                    </button>
                </div>

                {/* Modal Content */}
                <div className="p-6">

                    {/* allBatches Section */}
                    <div className="mt-6">
                        <h4 className="text-xl font-semibold mb-4">Batch Details</h4>
                        <div className="overflow-x-auto">
                            <table className="min-w-full table-auto border-collapse border border-gray-300">
                                <thead>
                                    <tr className="bg-gray-100">
                                        <th className="border px-4 py-2">Batch ID</th>
                                        <th className="border px-4 py-2">Total Emails</th>
                                        <th className="border px-4 py-2">Success Count</th>
                                        <th className="border px-4 py-2">Failure Count</th>
                                        <th className="border px-4 py-2">Send Time</th>
                                        <th className="border px-4 py-2">Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {allBatches.length > 0 ? (
                                        allBatches.map((batch) => (
                                            <tr key={batch.batch_id} className="hover:bg-gray-50">
                                                <td className="border px-4 py-2 text-sm text-gray-700">
                                                    {batch.batch_id}
                                                </td>
                                                <td className="border px-4 py-2 text-sm text-gray-700">
                                                    {batch.total_emails}
                                                </td>
                                                <td className="border px-4 py-2 text-sm text-green-600 font-bold">
                                                    {batch.success_count}
                                                </td>
                                                <td className="border px-4 py-2 text-sm text-red-600 font-bold">
                                                    {batch.failure_count}
                                                </td>
                                                <td className="border px-4 py-2 text-sm text-gray-700">
                                                    {new Date(batch.send_time).toLocaleString()}
                                                </td>
                                                <td className="border px-4 py-2 text-sm text-gray-700 capitalize">
                                                    {batch.status}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="6" className="text-center py-4 text-gray-500">
                                                No batch details available.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Close Button */}
                    <div className="mt-6 flex justify-end">
                        <button
                            onClick={onClose}
                            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CampaignBatchModal;